import {Card, Row, Col} from 'antd';
import {fixedToDisplayUnit, GRAMS_PER_LB_454} from "../../util/unitutils";
import {UnitType} from "../../api/Constants";

export const CultivationBonusCard = ({trim, props}) => {
    const cardStyle={
        textAlign: 'left'
    }
    const rowStyle = {
        marginTop: '5px',
        marginBottom: '5px'
    }

    let trimGrams = 0;
    for (let i=0; i<trim.length; i++) {
        trimGrams += trim[i].amount;
    }
    const displayGrams = fixedToDisplayUnit(trimGrams, UnitType.Gram)

    const trimLbs = (displayGrams / GRAMS_PER_LB_454);

    // this is a constant
    const bonusCutoff = 190.0

    // amount over cutoff
    let bonusLbs = trimLbs - bonusCutoff;
    bonusLbs = bonusLbs > 0 ? bonusLbs : 0;

    // average price, fixme
    const averagePrice = 900.0;

    // bonus rate
    const bonusRate = 0.15

    // bonus
    const bonus = bonusRate * averagePrice * bonusLbs;
    const bonusTextColor = (bonus > 0) ? 'green' : 'black'

    return <Card style={cardStyle} title={<b>Bonus</b>}>
        <Row style={rowStyle}>
            <Col span={2}>
                <b>Trim:</b>
            </Col>
            <Col>
                {`${displayGrams} ${UnitType.Label[UnitType.Gram]}`}
            </Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={2}>
                <b>Trim (lbs):</b>
            </Col>
            <Col>
                {`${trimLbs.toFixed(2)} lbs`}
            </Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={2}>
                <b>Bonus Cutoff:</b>
            </Col>
            <Col>
                {`${bonusCutoff} lbs`}
            </Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={2}>
                <b>Bonus Weight:</b>
            </Col>
            <Col>
                {`${bonusLbs.toFixed(2)} lbs`}
            </Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={2}>
                <b>Average Price:</b>
            </Col>
            <Col>
                {`$ ${averagePrice.toFixed(2)}`}
            </Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={2}>
                <b>Bonus Rate:</b>
            </Col>
            <Col>
                {`${(bonusRate*100).toFixed(0)} %`}
            </Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={2}>
                <b>Bonus:</b>
            </Col>
            <Col style={{color: bonusTextColor}}>
                {`$ ${bonus.toFixed(2)}`}
            </Col>
        </Row>
    </Card>
}